import script from "./PollsDataTable.vue?vue&type=script&setup=true&lang=js"
export * from "./PollsDataTable.vue?vue&type=script&setup=true&lang=js"

import "./PollsDataTable.vue?vue&type=style&index=0&id=457539be&scoped=true&lang=css"
import "./PollsDataTable.vue?vue&type=style&index=1&id=457539be&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-457539be"]])

export default __exports__